export default class Helper {
	static isLoggedIn = () => {
		return localStorage.getItem('access_token') !== null;
	};

	static removeToken = () => {
		localStorage.removeItem('access_token');
		localStorage.removeItem('user');
		localStorage.removeItem('user_permission');
	};

	static setLoader = (flag: boolean) => {
		const el = document.querySelector('.loader');
		if (el) {
			if (flag) {
				if (el.className.indexOf('with-background') > -1) {
					el.className = 'loader with-background is-spinning';
				} else {
					el.className = 'loader is-spinning';
				}
			} else if (el.className.indexOf('is-spinning') > -1) {
				let delay = 500;
				if (el.className.indexOf('with-background') > -1) {
					delay = 1100;
					setTimeout(() => {
						el.className = 'loader with-background is-spinning is-fading';
					}, 100);
				} else {
					setTimeout(() => {
						el.className = 'loader is-spinning is-fading';
					}, 200);
				}
				setTimeout(() => {
					el.className = 'loader';
				}, delay + 200);
			}
		}
	};

	static handleOnlyDigits = (event): void => {
		var regex = /[^0-9,.]/gi;
		const e = event.target as HTMLInputElement;

		e.value = e.value.replace(regex, '');
		if (e.value.includes(',') || e.value.includes('.')) {
			let parts = e.value.split(/[,.]/);
			e.value = parts[0] + ',' + (parts[1].length > 2 ? parts[1].substring(0, 2) : parts[1]);
		}
	};

	static isFunction = (functionToCheck) => {
		return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
	};
}
